import { useCallback } from 'react';
import { Edge } from 'reactflow';
import useFlowsStore from '../../../store/storeFlows';
import type { FlowTriggerAutosaveData } from '../../../util/autosave/flowTriggerAutosave.types';
import { nodeDataAutoSaveDynamic } from '../../../util/autosave/nodedata_autosave';

export type FlowNodePersistExtras = {
  flowTriggerData?: FlowTriggerAutosaveData;
  changeType?: string;
};

type SetSaving = (saving: {
  lastSaved?: string;
  status: string;
  finished?: boolean;
  flowId?: string;
}) => void;

type SetSchema = (
  schema: Record<string, { type: string; required: boolean }>,
) => void;

export function useFlowNodePersist(
  edges: Edge[],
  id: string,
  flowId: string | undefined,
  setNodeState: (value: unknown) => void,
  setSaving: SetSaving,
  setSchema: SetSchema,
) {
  return useCallback(
    (
      payload: Record<string, unknown>,
      extras?: FlowNodePersistExtras,
    ) => {
      if (useFlowsStore.getState().flowCanvasPhase !== 'ready') {
        return;
      }
      nodeDataAutoSaveDynamic({
        newEdges: edges,
        setNodeState,
        id,
        flowId,
        setSaving,
        objectData: payload,
        setSchema,
        flowTriggerData: extras?.flowTriggerData,
        changeType: extras?.changeType ?? 'default',
      });
    },
    [edges, setNodeState, id, flowId, setSaving, setSchema],
  );
}
